import Vue from 'vue'
import VueRouter from 'vue-router'
import DataExchange from '../views/DataExchange'
import PushDest from '../views/pageview/PushDest'
import DataConfig from '../views/pageview/DataConfig'

import Login from '../views/pageview/Login'
import LoginPage from '../views/login'
import DingTalkLogin from '../views/pageview/DingTalkLogin'

Vue.use(VueRouter)

const routes = [
  {
    path: '/user/login',
    component: LoginPage
  },
  {
    path: '/',
    name: '数据转换引擎',
    component: DataExchange,
    show: true,
    children: [
      {
        path: '/PushDest',
        name: '推送目标管理',
        show: true,
        component: PushDest
      },
      {
        path: '/DataConfig',
        name: '数据转换配置',
        show: true,
        component: DataConfig
      },
      {
        path: '/Login',
        name: '测试登录',
        show: false,
        component: Login
      },
      {
        path: '/DingTalkLogin',
        name: '钉钉登录',
        show: false,
        component: DingTalkLogin
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_ROUTER,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js